export default "__VITE_ASSET__DJFRGssU__"